import React, { useEffect } from "react";

const Alert = ({ type, msg, removeAlert, list }) => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      // removeAlert();
      removeAlert(false, "", "");
      // no need of writing this.
    }, 1600);
    return () => {
      clearTimeout(timeout);
    };
  }, [list, removeAlert]);
  return <p className={`alert alert-${type}`}>{msg}</p>;
};

export default Alert;
